module.exports = __webpack_public_path__ + "img/twitter.03fe5b0b.svg";